var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGoogleColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 12.7871C25.0001 11.9374 24.9298 11.0831 24.7798 10.2471H12.7507V15.0607H19.6392C19.3534 16.6131 18.4349 17.9864 17.09 18.8591V21.9824H21.1997C23.613 19.8053 25.0001 16.5901 25.0001 12.7871Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7507 25C16.1902 25 19.0909 23.8931 21.2043 21.9823L17.0946 18.8591C15.9512 19.6215 14.4751 20.0533 12.7554 20.0533C9.42829 20.0533 6.60729 17.8532 5.59511 14.8953H1.35425V18.115C3.5192 22.336 7.92876 25 12.7507 25Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59046 14.8953C5.05626 13.3428 5.05626 11.6618 5.59046 10.1093V6.88959H1.35429C-0.454522 10.4216 -0.454522 14.583 1.35429 18.115L5.59046 14.8953Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7507 4.94671C14.5689 4.91915 16.3261 5.58974 17.6429 6.82068L21.284 3.25187C18.9784 1.12988 15.9184 -0.0367566 12.7507 -1.21317e-05C7.92876 -1.21317e-05 3.5192 2.66396 1.35425 6.88957L5.59042 10.1093C6.59792 7.14678 9.4236 4.94671 12.7507 4.94671Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogleColor);
export default __webpack_public_path__ + "static/media/icon-google-color.58e98ab8447fef7bd62b4787d19d7e05.svg";
export { ForwardRef as ReactComponent };